import React from "react";
import { TERMS_INTERNAL } from "../../../enums/UrlPaths";
import LinkTo from "../../wrappers/LinkTo";
import { Stack, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";
import useUser from "../../../hooks/useUser";

export default function Bottom() {
  const { t } = useTranslation();
  const { roles } = useUser();
  return (
    <Stack
      spacing={3}
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        paddingBottom: "20px",
      }}
    >
      <Logo />
      <Typography
        variant="caption"
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {t("PoweredBy")}
        <div>
          {t("Read")}&nbsp;
          <LinkTo to={TERMS_INTERNAL}>{t("TermsAndConditions")}</LinkTo>
        </div>
      </Typography>
      {roles.master && process.env.REACT_APP_BUILD_LABEL && (
        <Typography variant="caption" sx={{ opacity: 0.5 }}>
          {process.env.REACT_APP_BUILD_LABEL}
        </Typography>
      )}
    </Stack>
  );
}
